export class NumericOptions {
  public digits: number = 1;
  public format: string = 'number';
  public iso: string = 'USD';
}
